import { Controller } from "@hotwired/stimulus"
import intlTelInput from "intl-tel-input/intlTelInputWithUtils"
import "intl-tel-input/dist/css/intlTelInput.css"

export default class extends Controller {
  static values = {
    initialCountry: { type: String, default: "id" },
    countryOrder:   { type: Array,  default: ["id", "sg", "au"] },
  }

  connect() {
    // Controller is on a wrapper div, not the input itself, so iti's DOM
    // reparenting of the input doesn't trigger a disconnect/reconnect loop.
    const input = this.element.querySelector("input[type=tel], input[type=text], input[type=phone]")
    if (!input || input._iti) return

    this._input = input
    const initialValue = input.value ? input.value.trim() : ""

    this._iti = intlTelInput(input, {
      initialCountry:   this.initialCountryValue,
      countryOrder:     this.countryOrderValue,
      separateDialCode: true,
    })

    if (initialValue) {
      let val = initialValue
      if (val && !val.startsWith("+") && !val.startsWith("0")) {
        val = "+" + val
      }
      this._iti.setNumber(val)
    }

    this._form = input.closest("form")
    if (this._form) {
      this._onSubmit = () => {
        let full = this._iti.getNumber()
        if (full) {
          if (full.startsWith("+")) {
            full = full.substring(1)
          }
          input.value = full
        }
      }
      this._form.addEventListener("submit", this._onSubmit)
    }
  }

  disconnect() {
    if (this._form && this._onSubmit) {
      this._form.removeEventListener("submit", this._onSubmit)
    }
    this._iti?.destroy()
    this._iti   = null
    this._input = null
    this._form  = null
  }
}
